import { computed } from '@angular/core';
import { signalStoreFeature, withComputed, withState } from '@ngrx/signals';

export type RequestStatus = 'idle' | 'pending' | 'fulfilled' | { error: string };

export type RequestStatusState = {
    status: RequestStatus;
};

export function withRequestStatus() {
    return signalStoreFeature(
        withState<RequestStatusState>({ status: 'idle' }),
        withComputed((store) => ({
            isPending: computed(() => store.status() === 'pending'),
            isFullfilled: computed(() => store.status() === 'fulfilled'),
            error: computed(() => {
                const status = store.status();
                return typeof status === 'object' ? status.error : undefined;
            }),
        })),
    );
}

export function setPending(): RequestStatusState {
    return { status: 'pending' };
}

export function setFulfilled(): RequestStatusState {
    return { status: 'fulfilled' };
}

export function setError(error: string): RequestStatusState {
    return { status: { error } };
}
